import apiService from './api.service';

export interface Plan {
  id: string;
  name: string;
  slug: string;
  description: string;
  price_monthly: number;
  price_yearly: number;
  price_annual: number;
  currency: string;
  stripe_price_id_monthly: string | null;
  stripe_price_id_yearly: string | null;
  features: string[];
  limits: {
    infraHosts?: number;
    kubernetesNodes?: number;
    apmTransactions?: number;
    logsVolume?: number;
    customMetrics?: number;
    retention?: number;
    users?: number;
  };
  is_public: boolean;
  is_active: boolean;
  sort_order: number;
}

/**
 * Detect user's preferred currency based on browser locale
 */
function detectCurrency(): 'USD' | 'BRL' {
  const lang = navigator.language || 'en-US';
  // If language is pt-BR or pt, default to BRL
  if (lang.toLowerCase().startsWith('pt')) {
    return 'BRL';
  }
  return 'USD';
}

const planApi = {
  /**
   * List all public plans available for signup
   * @param currency Optional currency override (USD or BRL)
   */
  async listPublic(currency?: 'USD' | 'BRL'): Promise<{ success: boolean; data: Plan[] }> {
    const currencyParam = currency || detectCurrency();
    return apiService.get(`/v1/plans?currency=${currencyParam}`);
  },
};

export default planApi;
